import { assetUrl } from '../render/assets';

/** URL dell'artwork "battler" CraftPix di una specie (480×480 → 256×256). */
export function battlerUrl(speciesId: string): string {
  return assetUrl(`battlers/${speciesId}.png`);
}

/** Texture d'erba usata come fondale della scena di battaglia. */
export function battleGroundUrl(): string {
  return assetUrl('ground/43.png');
}

export function propUrl(id: string): string {
  return assetUrl(`props/${id}.png`);
}
